__webpack_require__.p = "/total/image-translator/";